import {useSelector} from "react-redux";

const useIsAuthenticate = () => {

    const accesstoken = useSelector(state => {
        return state.authen.accesstoken
    })
    const isAuthenticated = () => {
        return !!accesstoken
    }

    return {
        isAuthenticated: isAuthenticated()
    }
}

export default useIsAuthenticate